export const productsAndServicesOptions = [
  "Login to HT-Bridge/Connector",
  "Login to HT-HRP/Health Reporsitory Providor",
  " Login to HT-Mate/Electronic Health Records",
];
